import axios from 'axios';

const availabilityUrl = uuid => `/api/internal/appointments/scheduler/${uuid}/availability/`;
const configUrl = uuid => `/api/internal/appointments/scheduler/${uuid}/config/`;
const bookingUrl = uuid => `/api/internal/appointments/scheduler/${uuid}/booking/`;
const editPreferencesUrl = uuid => `/api/internal/appointments/scheduler/${uuid}/client-preferences/`;
const nearbyCommunityUrl = (uuid, communityId) =>
    `/api/internal/appointments/scheduler/${uuid}/nearby-community/${communityId}`;

import { APPOINTMENT_TOUR_TYPE_GUIDED } from '../constants/config';

export default class API {
    constructor(uuid) {
        this.uuid = uuid;
    }

    // Note: if tour type is video we want to get the available of the guided tours
    fetchAvailableTimes(date, tourType = APPOINTMENT_TOUR_TYPE_GUIDED) {
        const params = {
            date,
            tour_type: tourType,
        };

        return axios.get(availabilityUrl(this.uuid), { params }).then(resp => resp.data);
    }

    editClientPreferences(data) {
        return axios.put(editPreferencesUrl(this.uuid), data).then(resp => resp.data);
    }

    saveAppointment(data) {
        return axios.post(bookingUrl(this.uuid), data).then(resp => resp.data);
    }

    rescheduleAppointment(data) {
        return axios.put(bookingUrl(this.uuid), data).then(resp => resp.data);
    }

    fetchInfo() {
        return axios.get(configUrl(this.uuid)).then(resp => resp.data);
    }

    createSchedulingLink = data => axios.post(configUrl(this.uuid), data).then(resp => resp.data);

    fetchNearbyCommunityData(communityId) {
        return axios.get(nearbyCommunityUrl(this.uuid, communityId)).then(resp => resp.data);
    }

    cancelAppointment() {
        return axios.delete(bookingUrl(this.uuid)).then(resp => resp.data);
    }
}
